"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InactiveHeader_1 = require("./InactiveHeader");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return InactiveHeader_1.default; } });
